/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsConstantContactFormViewProps } from '../../../modules/hosports-constant-contact-form/./hosports-constant-contact-form';
import ConstantContactForm from './../../../baseComponents/constant-contact-form/./constant-contact-form';


export default (props: IHosportsConstantContactFormViewProps) => {
  let config = props.config;
  return (
    <ConstantContactForm
      id={config.id}
      theme="dark"
    />
    )
};
